'use client'

import classNames from 'classnames'
import { ReactNode } from 'react'
import { GLOBAL_CLASSES } from '@/config/html-attributes.config'
import { handleIncomingString } from '@/utils/markdown.utils'
import IntrinsicElements = React.JSX.IntrinsicElements

type Props = {
  incomingString: string
  className?: string
  tagName?: 'div' | 'h2' | 'h3' | 'h4'
  useTypoStandard?: boolean
}

const StringToReactNode = ({
  incomingString,
  className,
  tagName = 'div',
  useTypoStandard = true,
  ...rest
}: Props): ReactNode => {
  const TagName = tagName as keyof IntrinsicElements
  const nextClassNames = useTypoStandard
    ? classNames(className, GLOBAL_CLASSES.TypoStandard)
    : classNames(className)

  const html = handleIncomingString(incomingString)

  return (
    <>
      <TagName
        {...(rest)}
        className={nextClassNames}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </>
  )
}

export default StringToReactNode
